'use client';

import { useGlobalUI, type HeaderCtaOverride } from 'contexts/GlobalUIContext';

type PageUIFlagsProps = {
  headerCollaspable?: boolean;
  liteUI?: boolean;
  footerDisabled?: boolean;
  headerCta?: HeaderCtaOverride;
};

/**
 * Tiny client island that applies page-level UI flags (lite UI / collapsible
 * header / disabled footer) via useGlobalUI and renders nothing. Lets an
 * otherwise-static page shell drop 'use client' and stay a Server Component,
 * keeping only this leaf on the client. Behaviour matches an inline
 * useGlobalUI({...}) call.
 */
export function PageUIFlags(props: PageUIFlagsProps) {
  useGlobalUI(props);
  return null;
}
